module.exports = __webpack_public_path__ + "assets/img/square-9.57653530.png";